import React, {useState} from 'react'
import useDidMountEffect from "../../../../../../hooks/useDidMountEffect/useDidMountEffect";
import Select from "react-select";
import {
    handleFind,
    handleFindDropdownMultiSelected,
    handleFindDropdownSelected,
    isNullOrUndefinded
} from "../../../../../../helper/utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Div} from "../../../../../registroMaternidad/modales/components/Components";
import {
    FlujoDocumentoRequiereExtradata,
    FlujoDocumentoScopeCampo, IdPlantillaDocumentoGenerico,
    IdTipoDistribucion
} from "../../../../constantes/constantes";
import InputSelect from "../../../../../../components/modalComponents/InputSelect";
import {
    descargarExcelPlantillaDistribucionAPI,
    validarRegistrarFlujoDocumentoPaso3API
} from "../../../../../../consumers/backendApisUrls";
import {useSubmitForm} from "../../../../../../hooks/useSubmitForm/useSubmitForm";
import {
    FirmaConvenioBeneficiosSteps
} from "../../../../../gestionDeBeneficios/ListarSolicitudes/crearSolicitudBeneficio/components/StyledComponents";
import InputUploadFile from "../../../../../../components/modalComponents/InputUploadFile";
import {
    useGenerarDescargarEliminarArchivo
} from "../../../../../../hooks/useGenerarDescargarEliminarArchivo/useGenerarDescargarEliminarArchivo";

const Paso3 = ({
                   sendCurrentStep,
                   setSendCurrentStep,
                   componentStep,
                   KEYS,
                   SECTION_NAME,
                   allDropdowns,
                   selectProps,
                   paso3Filtros,
                   setPaso3Filtros,
                   formValues,
                   setFormValues,
                   disableInputs
               }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitForm] = useSubmitForm();
    const [descargandoArchivo, setDescargandoArchivo] = useState(false);
    const [generarYDescargarArchivo] = useGenerarDescargarEliminarArchivo();

    useDidMountEffect(() => {
        if (sendCurrentStep?.step === componentStep && sendCurrentStep?.isSent) {
            handleSubmit();
        }
    }, [sendCurrentStep])

    useDidMountEffect(() => {
        if (formValues[KEYS.IdTipoDistribucion] === IdTipoDistribucion.PorFiltro.Id) {
            setFormValues(lastData => ({...lastData, [KEYS.ArchivoCargaDistribucion]: null}))
        }

        if (formValues[KEYS.IdTipoDistribucion] === IdTipoDistribucion.ConCarga.Id) {
            setPaso3Filtros([])
        }

    }, [formValues[KEYS.IdTipoDistribucion]])

    const handleSubmit = async (e) => {
        if (e) e.preventDefault();
        //setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
        //return

        setIsSubmitting(true);
        let api = "";
        let payload = {}
        let keys = [];

        api = validarRegistrarFlujoDocumentoPaso3API();
        payload = getPayload();
        keys = KEYS;

        try {
            await submitForm(Object.values(keys), api, payload, SECTION_NAME, successSubmitValidarCallback, false);
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    }

    const successSubmitValidarCallback = async ({data}) => {
        setSendCurrentStep(lastData => ({...lastData, isSent: false, isSaved: true}));
    }

    const handleChangeFilasMiltiSelect = (e, key, index) => {
        if (!isNullOrUndefinded(e)) {
            const newFilas = [...paso3Filtros];
            newFilas[index][key] = Array.isArray(e) ? e.map(x => x.value) : [];
            setPaso3Filtros(newFilas);
        }
    };

    const getPayload = () => {
        return {
            ValidarRegistrarFlujoDocumentoPaso3Filtros: paso3Filtros,
            ...formValues,
        }
    }

    const handleChangeFilas = (e, key, index) => {
        if (!isNullOrUndefinded(e?.value)) {
            const newFilas = [...paso3Filtros];
            newFilas[index][key] = e.value;
            newFilas[index]["IdsUnidades"] = [];
            newFilas[index]["IdsCargos"] = [];
            setPaso3Filtros(newFilas);
        }
    };

    const descargarPlantillaExcel = async (e) => {
        e.preventDefault();
        setDescargandoArchivo(true);
        const payload = {
            [KEYS.CantidadExtraDatas]: formValues[KEYS.CantidadExtraDatas],
        }
        await generarYDescargarArchivo(descargarExcelPlantillaDistribucionAPI(), payload);
        setDescargandoArchivo(false);
    }

    const getTipoDistribucionOptions = () => {
        if (formValues[KEYS.IdRequiereExtradataDistribucion] === FlujoDocumentoRequiereExtradata.si.Id)
            return handleFind(allDropdowns, KEYS.IdTipoDistribucion).filter(item => ([IdTipoDistribucion.ConCarga.Id]).includes(item.value))
        else
            return handleFind(allDropdowns, KEYS.IdTipoDistribucion)
    }

    return (
        <div>
            <div className="displayFlexWrap">
                <>
                    <div className="d-flex justify-content-between w-100 mb-2 mr-3">
                        <Div col={6}>
                            <InputSelect
                                label="Tipo"
                                {...selectProps(KEYS.IdTipoDistribucion)}
                                options={getTipoDistribucionOptions()}
                                sectionName={SECTION_NAME}
                                isRequired={true}
                                placeholder={"Seleccionar Tipo"}
                                direction="column"
                                isDisabled={disableInputs}
                            />
                        </Div>
                        {formValues[KEYS.IdTipoDistribucion] === IdTipoDistribucion.PorFiltro.Id && !disableInputs && (
                            <Div col={6} additionalClass={"d-flex justify-content-end align-items-end mb-2"}>
                                <button
                                    className="btn btn-primary generic-button-ficha-modal "
                                    onClick={(e) => {
                                        e && e.preventDefault();
                                        setPaso3Filtros([...paso3Filtros, {}]);
                                    }}
                                    disabled={paso3Filtros.length >= 2}
                                >
                                    Agregar
                                </button>
                            </Div>
                        )}
                    </div>

                    {formValues[KEYS.IdTipoDistribucion] === IdTipoDistribucion.PorFiltro.Id &&
                        <Div col={12}>
                            <>
                                <table className="table table-hover table-bordered">
                                    <thead className="listar-thead">
                                    <tr>
                                        <th className="table-header-bold col-md-3">Campo</th>
                                        <th className="table-header-bold col-md-3">Acción</th>
                                        <th className="table-header-bold col-md-3">Datos</th>
                                        {!disableInputs && <th className="table-header-bold">Acciones</th>}
                                    </tr>
                                    </thead>
                                    <tbody className="listar-tbody">
                                    {paso3Filtros &&
                                        paso3Filtros.map((row, i) => {
                                            return (
                                                <tr key={`${i}`}>
                                                    <td className="">
                                                        <Select
                                                            placeholder="Seleccionar"
                                                            value={handleFindDropdownSelected(
                                                                allDropdowns,
                                                                row,
                                                                KEYS.IdDocumentoScopeCampo
                                                            )}
                                                            options={isNullOrUndefinded(handleFind(allDropdowns, KEYS.IdDocumentoScopeCampo)) ? [] : handleFind(allDropdowns, KEYS.IdDocumentoScopeCampo).filter(item => !(paso3Filtros.map(item => item.IdDocumentoScopeCampo)).includes(item.value))}
                                                            onChange={(e) =>
                                                                handleChangeFilas(e, KEYS.IdDocumentoScopeCampo, i)
                                                            }
                                                            isMulti={false}
                                                            isDisabled={disableInputs}
                                                            isClearable
                                                        />
                                                    </td>
                                                    <td className="">
                                                        <Select
                                                            placeholder="Seleccionar"
                                                            value={handleFindDropdownSelected(
                                                                allDropdowns,
                                                                row,
                                                                KEYS.IdDocumentoScopeAccion
                                                            )}
                                                            options={handleFind(allDropdowns, KEYS.IdDocumentoScopeAccion)}
                                                            onChange={(e) =>
                                                                handleChangeFilas(e, KEYS.IdDocumentoScopeAccion, i)
                                                            }
                                                            isMulti={false}
                                                            isDisabled={disableInputs}
                                                            isClearable
                                                        />
                                                    </td>
                                                    <td className="">

                                                        {row.IdDocumentoScopeCampo === FlujoDocumentoScopeCampo.Cargo.Id &&
                                                            <Select
                                                                placeholder="Seleccionar"
                                                                value={handleFindDropdownMultiSelected(
                                                                    allDropdowns,
                                                                    row,
                                                                    KEYS.IdsCargos
                                                                )}
                                                                options={handleFind(allDropdowns, KEYS.IdsCargos)}
                                                                onChange={(e) =>
                                                                    handleChangeFilasMiltiSelect(e, KEYS.IdsCargos, i)
                                                                }
                                                                isMulti={true}
                                                                isDisabled={disableInputs}
                                                                isClearable
                                                            />
                                                        }


                                                        {row.IdDocumentoScopeCampo === FlujoDocumentoScopeCampo.Unidad.Id &&
                                                            <Select
                                                                placeholder="Seleccionar"
                                                                value={handleFindDropdownMultiSelected(
                                                                    allDropdowns,
                                                                    row,
                                                                    KEYS.IdsUnidades
                                                                )}
                                                                options={handleFind(allDropdowns, KEYS.IdsUnidades)}
                                                                onChange={(e) =>
                                                                    handleChangeFilasMiltiSelect(e, KEYS.IdsUnidades, i)
                                                                }
                                                                isMulti={true}
                                                                isDisabled={disableInputs}
                                                                isClearable
                                                            />
                                                        }

                                                    </td>
                                                    {!disableInputs && (
                                                        <td className="text-center">

                                                            <FontAwesomeIcon
                                                                icon="trash"
                                                                className="hand-pointer"
                                                                title="Eliminar"
                                                                onClick={() => {
                                                                    const newFilas = [...paso3Filtros];
                                                                    newFilas.splice(i, 1);
                                                                    setPaso3Filtros(newFilas);
                                                                }}
                                                            />

                                                        </td>
                                                    )}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                                <p
                                    className="ficha-form-input-validation-message"
                                    id={`ficha-edit-${SECTION_NAME}-Topes-validation-message`}></p>
                            </>

                        </Div>
                    }

                    {formValues[KEYS.IdTipoDistribucion] === IdTipoDistribucion.ConCarga.Id &&
                        <Div col={12}>

                            <FirmaConvenioBeneficiosSteps className="d-flex align-items-center justify-content-center">
                                <div className="column-step1 ">
                                    <div className="step-number">1</div>
                                    <div className="button">
                                        <button className="btn btn-primary generic-button-ficha"
                                                disabled={descargandoArchivo || disableInputs}
                                                onClick={(e) => {
                                                    descargarPlantillaExcel(e)
                                                }}> {descargandoArchivo ? 'Descargando...' : 'Descargar'}
                                        </button>
                                    </div>
                                </div>
                                {/* setIsUploading={setDisableSubmitButton}*/}
                                <div className="column-step2">
                                    <div className="step-number">2</div>
                                    <InputUploadFile
                                        name={KEYS.ArchivoCargaDistribucion}
                                        uploadFile={formValues[KEYS.ArchivoCargaDistribucion]}
                                        setUploadFile={(res) =>
                                            setFormValues({...formValues, [KEYS.ArchivoCargaDistribucion]: res})
                                        }
                                        sectionName={SECTION_NAME}

                                        validExtensions={["xlsx"]}
                                        isRequired={true}
                                        isDisabled={disableInputs}
                                        colLabel={0}
                                        colInput={12}
                                    />
                                </div>
                            </FirmaConvenioBeneficiosSteps>
                        </Div>
                    }
                </>
            </div>
        </div>
    )
}

export default Paso3;